import { render, staticRenderFns } from "./serveInfo.vue?vue&type=template&id=e948dc7e&scoped=true"
import script from "./serveInfo.vue?vue&type=script&lang=js"
export * from "./serveInfo.vue?vue&type=script&lang=js"
import style0 from "./serveInfo.vue?vue&type=style&index=0&id=e948dc7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e948dc7e",
  null
  
)

export default component.exports